
'use client';

import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useAppTheme } from "@/provider/ThemeProvider";
import RenderIf from "@/components/render-if";


function ToggleTheme({ withName = false, withIcon = true }) {
    const { isDark, toggleTheme, setTheme } = useAppTheme();
    const [mounted, setMounted] = useState(false);


    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;


    return (
        <div>
            <button
                type="button"
                onClick={() => setTheme(isDark ? 'light' : 'dark')}
                className="mx-3 w-8 h-8 rounded-full flex items-center justify-center  transition-colors   dark:text-slate-300 text-sm"
                aria-label={'تغییر تم'}
                title={isDark ? 'روشن' : 'تاریک'}
            >
                <RenderIf condition={withIcon && !withName}>
                    {isDark ? <Sun size={18} /> : <Moon size={18} />}
                </RenderIf>

                <RenderIf condition={withName}>
                    <div className="flex items-center gap-2">
                        {withIcon && (
                            isDark
                                ? <Sun size={18} />
                                : <Moon size={18} />
                        )}

                        <span>
                            {isDark ? 'روشن' : 'تاریک'}
                        </span>
                    </div>
                </RenderIf>
            </button>
        </div>
    );
}

export default ToggleTheme;
